export const ResponderTypes = [
  { value: 'MEMBER', name: 'Member' },
  { value: 'PROVIDER', name: 'Provider' },
];
